import { Alert, Chip, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import type { HotelCancelPenaltyBody, HotelCancelPenaltyPrice } from '../../../api/types/hotel';

/** `body.cancelPenalties[]` breakdown from `Hotel/GetReservationCancelPenalty`, shown in
 *  the cancel confirm dialog BEFORE `Hotel/GetReservationCancel` runs. Plain MUI Table
 *  (no `@mui/x-data-grid`). One row per service; penalty amounts come from
 *  `priceDetail.penalty`, falling back to the penalty item's own `price`. */
function fmtPrice(p?: HotelCancelPenaltyPrice | null): string {
  if (!p || p.amount === undefined || p.amount === null) return '—';
  const amount = p.amount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${amount} ${p.currency ?? ''}`.trim();
}

export function HotelCancelPenaltyBreakdown({ body }: { body?: HotelCancelPenaltyBody | null }) {
  const penalties = body?.cancelPenalties ?? [];

  if (!penalties.length) {
    return <Alert severity="info">Bu rezervasyon için ceza kırılımı bilgisi bulunamadı.</Alert>;
  }

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2">İptal Ceza Kırılımı</Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Hizmet</TableCell>
            <TableCell align="right">Toplam</TableCell>
            <TableCell align="right">Ceza</TableCell>
            <TableCell align="center">İptal Edilebilir</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {penalties.flatMap((pen, pi) => {
            const rows = pen.services?.length ? pen.services : [null];
            return rows.map((svc, si) => {
              const cancelable = svc?.isCancelable ?? pen.isCancelable;
              return (
                <TableRow key={`${pi}-${si}`}>
                  <TableCell>{svc?.name ?? pen.reason?.name ?? 'Rezervasyon'}</TableCell>
                  <TableCell align="right">{fmtPrice(svc?.priceDetail?.totalSalePrice ?? pen.price)}</TableCell>
                  <TableCell align="right">{fmtPrice(svc?.priceDetail?.penalty ?? pen.price)}</TableCell>
                  <TableCell align="center">
                    <Chip
                      size="small"
                      color={cancelable ? 'success' : 'default'}
                      label={cancelable ? 'Evet' : 'Hayır'}
                    />
                  </TableCell>
                </TableRow>
              );
            });
          })}
        </TableBody>
      </Table>
    </Stack>
  );
}
